module.exports = __webpack_public_path__ + "static/media/logout.39a05ad7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logout.svg
// module id = 1841
// module chunks = 2